import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

export const StyledModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  display: flex;
  width: 500px;
  padding: 32px;
  flex-direction: column;
  border-radius: 8px;
  background: ${commonColors.white};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);

  > svg {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 12px;
    top: 12px;
    cursor: pointer;

    path {
      fill: ${commonColors.grey500};
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    > p {
      color: ${commonColors.grey700};
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      line-height: 25px;
      margin: 12px 0;

      > span {
        color: ${commonColors.blue700};
        font-weight: 600;
      }
    }

    > div {
      color: ${commonColors.grey700};
      text-align: center;
      font-family: Univers-Light;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
    }

    > button {
      width: max-content;
      margin-top: 32px;
      background: ${commonColors.white};
      font-weight: 700;
    }
  }
`;
